if (getComputedStyle(document.documentElement).getPropertyValue('--sm-disable-fx').trim() === '1') {
  return;
}
(function(){
  // mobile only
  if (!window.matchMedia('(hover:none) and (pointer:coarse)').matches) return;

  const SPRITE_URL = 'https://cdn.shopify.com/s/files/1/0942/9804/6830/files/Untitled_design_5.svg?v=1761868711';
  const NAV_DELAY = 180;   // ms
  const DURATION  = 550;   // ms

  let lastTouch = 0;
  // Preload once; no CORS text fetch, just an image that the browser caches.
  const SPRITE_IMG = new Image();
  SPRITE_IMG.decoding = 'async';
  SPRITE_IMG.src = SPRITE_URL;

  function splash(x, y){
    const wrap = document.createElement('div');
    wrap.style.cssText = [
      'position:fixed','pointer-events:none','z-index:2147483647',
      `left:${x-24}px`,`top:${y-24}px`,`width:48px`,`height:48px`,
      'transform:scale(.6)','opacity:.98','will-change:transform,opacity',
      `transition:transform ${DURATION}ms cubic-bezier(.2,.8,.2,1),opacity ${DURATION}ms ease`
    ].join(';');

    const img = document.createElement('img');
    img.alt = ''; img.width = 48; img.height = 48; img.style.display = 'block';
    // Using same URL hits cache; no network on tap.
    img.src = SPRITE_IMG.src;

    wrap.appendChild(img);
    document.body.appendChild(wrap);
    requestAnimationFrame(()=>{ wrap.style.transform='scale(1.7)'; wrap.style.opacity='0'; });
    setTimeout(()=>wrap.remove(), DURATION + 100);
  }

  // Draw on any touch pointerdown. No selector gate.
  function onPD(ev){
    if (ev.pointerType && ev.pointerType !== 'touch' && ev.pointerType !== 'pen') return;
    lastTouch = Date.now();
    const x = ev.clientX ?? (ev.touches && ev.touches[0] && ev.touches[0].clientX) ?? 0;
    const y = ev.clientY ?? (ev.touches && ev.touches[0] && ev.touches[0].clientY) ?? 0;
    splash(x, y);
  }
  document.addEventListener('pointerdown', onPD, { passive: true });
  // Fallback for older iOS that may deliver touchstart earlier
  document.addEventListener('touchstart', (e)=>{ if (Date.now()-lastTouch>20) onPD({pointerType:'touch', touches:e.touches}); }, { passive: true });

  // Delay only touch-originated <a href> navigations so splash is visible
  document.addEventListener('click', function(ev){
    if (Date.now() - lastTouch > 500) return;
    const a = ev.target.closest && ev.target.closest('a[href]');
    if (!a) return;
    if (a.hasAttribute('data-no-splash-delay')) return;
    ev.preventDefault();
    const href = a.href, tgt = a.getAttribute('target');
    setTimeout(()=>{ tgt === '_blank' ? window.open(href, '_blank') : (location.href = href); }, NAV_DELAY);
  }, true);
})();